module.exports = __webpack_public_path__ + "img/Sycamore 960x1080 v2.dfc70ce7.png";